import React from "react";
import "./style.css";
import approvedImage from "../../../../../Assets/Icons/verified.svg";
import refusedImage from "../../../../../Assets/Icons/verified_off.svg";
import InitialsAvatar from "../../../../../Components/InitialsAvatar";

const GenericInformationCard = ({
  headerIcon,
  headerTitle,
  bodyIcon,
  bodyInitials,
  bodyTitleOne,
  bodySubTitleOne,
  bodyTitleTwo,
  bodySubTitleTwo,
  bodyTitleThree,
  bodySubTitleThree,
  bodyTitleFour,
  bodySubTitleFour,
  validated = false,
  isImage = false,
}) => {
  return (
    <div className="transaction-info-card">
      {/* Header */}
      <div className="card-info-header">
        <div className="card-info-title">
          <img className="card-icon" src={headerIcon} />
          <span>{headerTitle}</span>
        </div>

        <span className={`status-badge ${validated ? "active" : "locked"}`}>
          <img
            src={validated ? approvedImage : refusedImage}
            alt="Approved/Refused Icon"
            className="status-icon"
          />
          <div className="status-text">
            {validated ? "Validated" : "Refused"}
          </div>
        </span>
      </div>

      {/* Body */}
      <div className="card-info-body">
        {/* Left Side - User */}
        {!bodyIcon && bodyInitials !== undefined ? (
          <div className="card-left-side is-initials">
            <InitialsAvatar
              name={bodyInitials}
              style={{
                width: "100%",
                height: "100%",
                borderRadius: 16,
                fontSize: 20,
              }}
            />
          </div>
        ) : (
          <div
            className={`card-left-side ${isImage ? "is-image" : "is-icon"}`}
          >
            <img src={bodyIcon} className="body-image" alt="body visual" />
          </div>
        )}

        {/* Right Side - Details */}
        <div className="card-right-side">
          <div className="detail-item">
            <div className="label">{bodyTitleOne}</div>
            <div className="detail-value">{bodySubTitleOne}</div>
          </div>

          <div className="detail-item">
            <div className="label">{bodyTitleTwo}</div>
            <div className="detail-value">{bodySubTitleTwo}</div>
          </div>

          <div className="detail-item">
            <div className="label">{bodyTitleThree}</div>
            <div className="detail-value">{bodySubTitleThree}</div>
          </div>
          <div className="detail-item">
            <div className="label">{bodyTitleFour}</div>
            <div className="detail-value">{bodySubTitleFour}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GenericInformationCard;
